import { Component, input, InputSignal } from '@angular/core';
import { CompanyGroupsCompanyNodeComponent } from '@app/shared/components/groups/company-groups-company-node/company-groups-company-node.component';
import { Group } from '@app/shared/types/models/group/group.model';

@Component({
  selector: 'proffeo-company-groups-list',
  imports: [CompanyGroupsCompanyNodeComponent],
  templateUrl: './company-groups-list.component.html'
})
export class CompanyGroupsListComponent {
  public companyGroup: InputSignal<Group | undefined> = input();
}
